import './App.css';

function App() {
    return (
        <div className="App">
            {/* Top bar with login */}
            <div className="App-topbar">
                <a href="https://www.solbid.com/login" className="Login-link">Login</a>
            </div>

            <header className="App-header">
                <img
                    src="/assets/img/horizonxl_v1_master_tm.png"
                    className="App-logo"
                    alt="HorizonXL Logo"
                />

                {/* CTA Button */}
                <a href="https://www.solbid.com/request-a-demo" className="cta-button">
                    Request Demo
                </a>

                    {/* Section Start */}
                    <div className="section-row-top">
                        <div className="section-content col-text">
                            <h3 className="section-title">The All-In-One AI-driven Commercial Solar Platform</h3>
                            <div className="section-desc">
                                <p>
                                    HorizonXL is an <strong>AI-driven</strong> solution built for clean energy professionals — combining intelligent system design, procurement automation, and deployment planning in one seamless interface.
                                </p>
                            </div>
                        </div>

                        <div className="section-image col-image">
                            <img src="/assets/img/horizonxl_design_tool.jpg" alt="HorizonXL Interface" />
                        </div>
                    </div>
                {/* Section End */}
                {/* Section Start */}
                <div className="section-row" style={{ paddingBottom: "125px" }}>
                    <div className="section-image col-image">
                        <img src="/assets/img/horizonxl_graphs.jpg" alt="HorizonXL Dashboard" style={{ maxWidth: "475px" }} />
                    </div>

                    <div className="section-content col-text">
                        <h3 className="section-title">Design Smarter with AI</h3>
                        <div className="section-desc">
                            <p>
                                Generate <strong>instant, accurate proformas</strong> that incorporate real-time utility rates, incentive programs, and site-specific variables across the U.S.
                                From AI-generated layouts to procurement-ready BOMs, HorizonXL simplifies complexity so you can scale faster, design smarter, and win more projects.
                            </p>
                        </div>
                    </div>
                </div>
                {/* Section End */}

                <div className="social-bar">
                    <p className="social-label">Follow Us</p>
                    <div className="social-icons">
                        <a href="https://www.linkedin.com/company/solbid" target="_blank" rel="noreferrer">
                            <i className="fab fa-linkedin"></i>
                        </a>
                        <a href="https://www.facebook.com/solbid" target="_blank" rel="noreferrer">
                            <i className="fab fa-facebook"></i>
                        </a>
                        <a href="https://www.instagram.com/solbidsolar" target="_blank" rel="noreferrer">
                            <i className="fab fa-instagram"></i>
                        </a>
                        <a href="https://twitter.com/solbidinc" target="_blank" rel="noreferrer">
                            <i className="fab fa-x-twitter"></i>
                        </a>
                    </div>
                </div>

            </header>

            <footer className="App-footer">
                © 2025 HorizonXL, Inc. All rights reserved. HorizonXL™ is a trademark of HorizonXL, Inc., a <a href="https://www.solbid.com">SolBid</a> company. | Contact: 1-857-233-9283
            </footer>
        </div>
    );
}

export default App;
